import script from "./DomainView.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainView.vue?vue&type=script&setup=true&lang=js"

import "./DomainView.vue?vue&type=style&index=0&id=e1a2385e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1a2385e"]])

export default __exports__